import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import {routes} from './routes';
import {ApolloClient} from 'apollo-client';
import {HttpLink} from 'apollo-link-http';
import {InMemoryCache} from 'apollo-cache-inmemory';
//const VueApollo = require('vue-apollo').default;
import gql from 'graphql-tag';
import {setContext} from 'apollo-link-context';
import {GraphQLClient} from 'graphql-request';
import Store from './vuexstore.js';
import Vuex from 'vuex';

Vue.use(Vuex); 
const store = new Vuex.Store(Store);
Vue.config.productionTip = false

const router = new VueRouter({
  routes, // short for `routes: routes`
//  history: true,
  mode: 'history',
})
Vue.use(VueRouter)


// global variables
let global = {};
global.graphqlEndpoint = null;
if (!global.graphqlEndpoint) {
  global.graphqlEndpoint = 'http://localhost:8000/graphql';
  global.apiEndPoint = 'http://localhost:8000/api'
  
  global.graphqlEndpoint = 'https://api.rinble.com/graphql';
  global.apiEndPoint = 'https://api.rinble.com/api'
  //global.server = window.location.protocol + '//' + window.location.hostname + ':8000'
  //global.graphqlEndpoint = global.server + '/graphql';
  //global.apiEndPoint = global.server + '/api';
}

// HTTP connexion to the API
const httpLink = new HttpLink({
  // You should use an absolute URL here
  uri: global.graphqlEndpoint,
})

// Cache implementation
const cache = new InMemoryCache()

const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: store.getters.authorizationToken ? `${store.getters.authorizationToken}` : "",
      }
    }
});

// Create the apollo client
const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
  connectToDevTools: true,
});
global.apolloClient = apolloClient;

const gqlClientFunction = function() {
  // console.log('LEVON erkljhdlkfjdsaf');
  // console.log(global.click2call_token);
  return new GraphQLClient(global.graphqlEndpoint, {
    headers: {
      authorization: store.getters.authorizationToken ? `${store.getters.authorizationToken}` : "",
    },
  });
};


global.gqlClient = gqlClientFunction;
global.gql = gql;


Vue.config.productionTip = false


Vue.prototype.$global = global;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
